// Общие хелперы вкладок Dashboard (Обзор + OTA-аналитика).
import * as api from '../../utils/api';

export const curMonth = () => new Date().toISOString().slice(0, 7);
export const addMonth = (ym, d) => {
  const [y, m] = String(ym).split('-').map(Number);
  const dt = new Date(Date.UTC(y, (m - 1) + d, 1));
  return `${dt.getUTCFullYear()}-${String(dt.getUTCMonth() + 1).padStart(2, '0')}`;
};

// Рабочее окно TravelLine-синка на бэке — пред/тек/след месяц
// (server/routes/travelline.js). Вне него tl_bookings обновляется только по
// явному запросу с этим месяцем.
const inSyncWindow = (month) => {
  const cur = curMonth();
  return month === addMonth(cur, -1) || month === cur || month === addMonth(cur, 1);
};

// Месяцы вне рабочего окна, уже подгруженные за сессию — общий для всех
// карточек Dashboard, чтобы не дублировать синк одного месяца.
const tlLazyMonths = new Set();

// Ленивая подгрузка месяца вне рабочего окна (аналог механизма в
// Bookings.jsx): запускает фоновый синк TravelLine и опрашивает статус до
// завершения, затем вызывает onDone() для тихого обновления данных. Без
// этого «Брони на руках» для дальних месяцев берутся из устаревших
// tl_bookings — синк для них идёт только по явному запросу месяца.
export function lazySyncMonth(month, canSync, onDone) {
  if (!canSync || inSyncWindow(month) || tlLazyMonths.has(month)) return;
  tlLazyMonths.add(month);
  api.post('/travelline/sync', { month }).catch(() => {});
  const poll = () => {
    api.get('/travelline/sync-status').then(s => {
      if (s.running) setTimeout(poll, 5000);
      else onDone();
    }).catch(() => {});
  };
  setTimeout(poll, 5000);
}
export const monthLabel = (ym) => {
  const M = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
  const [y, m] = String(ym).split('-').map(Number);
  return `${M[m - 1]} ${String(y).slice(2)}`;
};

// «октябрь 2026» — полное название месяца для заголовков.
export const monthFull = (ym) => {
  const M = ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'];
  const [y, m] = String(ym).split('-').map(Number);
  return `${M[m - 1]} ${y}`;
};

export const fmt  = n => new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB', maximumFractionDigits: 0 }).format(n ?? 0);
export const pct  = n => `${Math.round((n ?? 0) * 100)}%`;
export const pct1 = n => `${((n ?? 0) * 100).toFixed(1)}%`;

// ─── Цвета каналов (только для графиков; в tokens.css категориальной палитры нет) ──
// Прямые: Сайт — зелёный (наш канал), Оператор — синий. OTA — стабильная палитра
// по channel_key (одинаковый цвет в баре и в динамике). «Прочие» — серый.
const KIND_BASE = {
  website:  '#4A7C59',   // green = наш сайт
  operator: '#2F6B9A',   // blue  = оператор/стойка
  other:    '#8A6A66',   // muted
};
const OTA_RAMP = ['#F5644A', '#B07D2A', '#7A3B8C', '#3D8C7A', '#C44E8A', '#5A6ACF', '#2A9D8F', '#E07A3F'];

// Строит карту channel_key → цвет. OTA-каналы раскрашиваются детерминированно
// (по отсортированному списку ключей), чтобы цвет был стабилен между визуализациями.
export function buildColorMap(keysWithKind) {
  const otaKeys = keysWithKind.filter(x => x.kind === 'ota').map(x => x.channel_key).sort();
  const idx = {}; otaKeys.forEach((k, i) => { idx[k] = i; });
  const map = {};
  for (const { channel_key, kind } of keysWithKind) {
    if (channel_key === '__OTHER__') map[channel_key] = KIND_BASE.other;
    else if (kind === 'ota') map[channel_key] = OTA_RAMP[idx[channel_key] % OTA_RAMP.length];
    else map[channel_key] = KIND_BASE[kind] || KIND_BASE.other;
  }
  return map;
}
